<template>
    <div>
        <slot v-if="hasGoogleConnection"></slot>
        <br>
        <button @click="getAuthUrl" class="google-sign-in">
            <div class="google-logo">
                <img style="vertical-align: unset;" src="@/assets/images/google-logo-icon-sign-in.svg" width="16px" height="16px">
            </div>
            <div class="google-text">
                {{hasGoogleConnection ? 'Use another Google account' : 'Sign in with Google' }}
            </div>
        </button>
    </div>
</template>

<script>
import { ErrorService } from "@/main";
import notification from "@/mixins/notification";
import * as Sentry from "@sentry/browser";
import Resource from "@/components/integrations/google-analytics-oauth/oauth/Resource"
import {UserService} from "@/main";

export default {
    mixins: [notification],

    data() {
        return {
            hasGoogleConnection: false,
        }
    },

    methods: {
        async getAuthUrl() {
            try {
                const res = await Resource.getAuthUrl(this.$route.fullPath);
                window.location.href = res.data.uri;
            } catch (e) {
                this.showNotification(
                    "error-notification",
                    "Oops! We have a problem",
                    ErrorService.getErrorMessage(
                        e.networkError.result.errors[0]
                    )
                );
                Sentry.captureException(e);
                console.log(e);
            }
        },

        init() {
            UserService.getInfo().then(res => {
                const user = res.data.me;
                this.hasGoogleConnection = user.has_google_connection
            })
        }
    },

    created() {
        console.info('created')
        setTimeout(() => this.init(), 100);
    },

};
</script>
